module.exports = __webpack_public_path__ + "static/img/main-top.9f5fb078.png";